import { c as _c } from "react/compiler-runtime";
import { Price } from '@7f-ui/components/price';
import { shopTestId } from '@utils/utils-shop-test-ids';
export interface CategoryPriceLabelProps {
  title: string;
  description: string;
  price?: number;
}
export function CategoryPriceLabel(t0) {
  const $ = _c(13);
  const {
    title,
    description,
    price
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = shopTestId("CategoryPriceLabel.title");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <div data-testid={t1} className="font-heading5">{title}</div>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== description) {
    t3 = <div className="font-body-small">{description}</div>;
    $[3] = description;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== price) {
    t4 = !!price && <div className="font-body-small"><Price amount={price} />{" / Person"}</div>;
    $[5] = price;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="flex flex-col sm:flex-row sm:space-x-4">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = <div>{t2}{t5}</div>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}